export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/close-0479cc57e2b3311f25246f635cde4581.svg";